<template>

    <div id="dialog_back"></div>

    <div id="dialog">

        <div class="text">
            <h2>{{ ui.getDialog.title }}</h2>
            <p v-if="ui.getDialog.message" v-html="ui.getDialog.message"></p>
        </div>

        <input v-if="ui.getDialog.type === 'input'" type="text" v-model="callBackData" :class="[notValid ? 'notValid': ''].join(' ')" @input="() => {notValid = false}">

        <input v-if="ui.getDialog.type === 'color'" type="color" v-model="callBackData">

        <div v-if="ui.getDialog.type === 'password'">
            <input type="password" v-model="callBackData" :class="[notValid ? 'notValid': ''].join(' ')" @input="() => {notValid = false}">
            <input type="password" v-model="checkData" :class="[notValid ? 'notValid': ''].join(' ')" @input="() => {notValid = false}">
        </div>

        <ul v-if="ui.getDialog.type === 'users' && callBackData" :style="{maxHeight: (ui.innerHeight * 0.4) + 'px'}">
            <li v-for="user in users.allEditors" :key="user.name + user.id" @click="() => {addOrRemoveUser(user.id)}"
                :class="[callBackData.has(user.id) ? 'active' : '', systemData.has(user.id) ? 'locked' : ''].join(' ')">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M234-276q51-39 114-61.5T480-360q69 0 132 22.5T726-276q35-41 54.5-93T800-480q0-133-93.5-226.5T480-800q-133 0-226.5 93.5T160-480q0 59 19.5 111t54.5 93Zm246-164q-59 0-99.5-40.5T340-580q0-59 40.5-99.5T480-720q59 0 99.5 40.5T620-580q0 59-40.5 99.5T480-440Zm0 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q53 0 100-15.5t86-44.5q-39-29-86-44.5T480-280q-53 0-100 15.5T294-220q39 29 86 44.5T480-160Zm0-360q26 0 43-17t17-43q0-26-17-43t-43-17q-26 0-43 17t-17 43q0 26 17 43t43 17Zm0-60Zm0 360Z"/></svg>
                <p>{{ user.name }}</p>
                <svg v-if="callBackData.has(user.id)" class="svgRight" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                <svg v-else-if="systemData.has(user.id)" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z"/></svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
            </li>
        </ul>

        <div v-if="ui.getDialog.type === 'radio' && Array.isArray(callBackData)" class="radioBox">
            <template v-for="(radioItem, i) in callBackData" :key="radioItem.value">
                <input type="radio" :id="'radio-' + i" :value="radioItem.value" :checked="radioItem.checked" name="radio"/>
                <label :for="'radio-' + i" @click="() => {setRadioData(radioItem.value)}">
                    <div class="checker">
                        <div></div>
                    </div>
                    <p>
                        {{ radioItem.text }}
                    </p>
                </label>
            </template>
        </div>

        <div class="buttons">
            <button @click="() => {buttonsHandler(false)}" class="buttonCancel">{{ ui.getDialog.cancelButton }}</button>
            <button @click="() => {buttonsHandler(true)}" class="buttonOk">{{ ui.getDialog.okButton }}</button>
        </div>
    </div>
</template>

<script>
    import { useUI } from '@/store/ui';
    import { useUsers } from '@/store/users';

    export default {
        setup() {
            return {
                ui: useUI(),
                users: useUsers()
            }
        },

        data() {
            return {
                callBackData: null,
                checkData: null,
                systemData: null,
                notValid: false,
            }
        },
        
        methods: {
            buttonsHandler(payload) {

                if (payload && this.ui.getDialog.type === 'input' && !this.callBackData) {
                    this.notValid = true;
                    return;
                }

                if (payload && this.ui.getDialog.type === 'password') {

                    if (
                        !this.callBackData ||
                        !this.checkData ||
                        this.callBackData !== this.checkData || 
                        this.callBackData.length < 8 ||
                        this.checkData.length < 8
                    ) {
                        this.notValid = true;
                        return;
                    }
                }

                if (this.ui.getDialog.callBack) {
                    const result = this.ui.getDialog.callBack({data: this.callBackData, status: payload});
                    if (Promise.resolve(result) === result) {
                        result.then((res) => {
                            if (res !== true) this.ui.deleteDialog();
                        });
                    } else {
                        if (result !== true) this.ui.deleteDialog();
                    }
                }
            },

            setInitData() {
                if (!this.ui.getDialog.initData) return;

                switch (this.ui.getDialog.type) {
                    case 'input':
                    case 'radio':
                        this.callBackData = this.ui.getDialog.initData;
                        break;
                    case 'color':
                        if (this.ui.getDialog.initData.startsWith('#'))
                            this.callBackData = this.ui.getDialog.initData;
                        break;
                    case 'users':
                        if (this.ui.getDialog.initData.allow) this.callBackData = this.ui.getDialog.initData.allow;
                        else this.callBackData = new Set();
                        if (this.ui.getDialog.initData.locked) this.systemData = this.ui.getDialog.initData.locked;
                        else this.systemData = new Set();
                        break;
                }

            },

            addOrRemoveUser(id) {
                if (this.systemData.has(id)) {
                    this.ui.setNotification('warning', `Користувач вже мае доступ до папки`, 'user-have-access');
                    return;
                } 
                const isExist = this.callBackData.has(id);
                if (isExist) this.callBackData.delete(id);
                else this.callBackData.add(id);
            }, 

            setRadioData(value) {
                this.callBackData = this.callBackData.map((item) => {
                    if (value === item.value) item.checked = true;
                    else item.checked = false;
                    return item;
                });
            }
        },

        mounted() {
            this.setInitData();
        }
    }

</script>

<style lang="scss" scoped>
    @import "@/assets/css/vars.scss";

    #dialog_back {
        position: fixed;
        top: 0;
        left: 0;
        background-color: $brand_black_05;
        width: 100%;
        height: 100%;
        z-index: 9;
    }

    #dialog {
        position: fixed;
        top: 50%;
        left: 50%;
        z-index: 10;
        transform: translate(-50%, -50%);
        background-color: $brand_white;
        box-shadow: $box_shadow;
        padding: 20px;
        max-width: 800px;
        max-height: 90%;
        overflow: auto;
        @include _460 {
            width: 90%;
        }
        text-align: center;

        .text {
            margin-bottom: 20px;
            p {
                margin-top: 20px;
                overflow: auto;
            }
        }

        input {
            margin-bottom: 20px;

            &.notValid {
                background: $color_light_red;
            }
        }

        ul {
            overflow: auto;
            margin-bottom: 20px;

            li {
                text-align: left;
                display: flex;
                align-items: center;
                cursor: pointer;
                background: $brand_black_03;
                margin: 5px 0;
                padding: 5px;
                border-radius: 50px;

                &.active {
                    background: $brand_primary;
                }

                &.locked {
                    background: $color_orange;
                }

                svg {
                    margin-right: 5px;
                }

                p {
                    color: #fff;
                    flex: 1;
                }

            }
        }

        .radioBox {
            input {
                display: none;

                &:checked + label {
                    .checker div {
                        background: $brand_primary;
                    }
                }
            }
            label {
                display: flex;
                align-items: center;
                margin: 10px 0;
                .checker {
                    width: 20px;
                    height: 20px;
                    border: solid 1px #000;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 10px;

                    div {
                        width: 15px;
                        height: 15px;
                    }

                }
            }
        }

        .buttons {
            display: flex;
            align-items: center;
            justify-content: space-between;

            @include _380 {
                display: block;
            }

            .buttonOk {
                margin-left: 10px;
                @include _380 {
                    margin: 10px auto 0;
                }
            }
            .buttonCancel {
                margin-right: 10px;
                @include _380 {
                    margin: 0 auto;
                }
            }

        }
    }

</style>